import logo from './logo.svg';
import './App.css';
// styles
import "bootstrap/scss/bootstrap.scss";
import "assets/scss/paper-kit.scss?v=1.3.0";
import "assets/demo/demo.css?v=1.3.0";
import 'assets/css/contact-form.css';
import 'assets/css/product-cards.scss';
import 'assets/css/main-page-products.scss';
import 'assets/css/gallery.scss';
import 'assets/css/contact-page.scss';
import 'assets/css/nav-links.scss';
import 'assets/css/blog-card.scss';
import 'assets/css/project-card.scss';

import Home from "./pages/Home";

import {BrowserRouter, Routes, Route, Link} from 'react-router-dom';
import Products from "./pages/Products";
import ExamplesNavbar from "./components/Navbars/ExamplesNavbar";
import React from "react";
import DemoFooter from "./components/Footers/DemoFooter";
import Projects from "./pages/Projects";
import Project from "./pages/Project";
import Contact from "./pages/Contact";
import ArticlePage from "./pages/Article";
import Layout from "./components/Layout";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout/>}>
                    <Route index element={<Home/>}/>
                    <Route path="products" element={<Products/>}/>
                    <Route path="projects" element={<Projects/>}/>
                    <Route path="contact" element={<Contact/>}/>
                    <Route path=":slug" element={<ArticlePage/>}/>
                    <Route path="projects/:slug" element={<Project/>}/>


                </Route>
            </Routes>
        </BrowserRouter>


    );
}

export default App;
